/* Novaris mobile bottom navigation — native Impulse drawer triggers.
 * v11: Categorías and Carrito use Impulse's own js-drawer-open-* classes directly.
 * This file only provides a safe fallback if a drawer is unavailable.
 */
(function () {
  'use strict';
  if (window.NovarisMobileBottomNavV11) return;
  window.NovarisMobileBottomNavV11 = { version: '1.2.0' };

  var mq = window.matchMedia('(max-width: 768px)');

  document.addEventListener('click', function (event) {
    if (!mq.matches) return;

    var categories = event.target.closest('[data-nv-mobile-categories]');
    if (categories) {
      var navDrawer = document.getElementById('NavDrawer');
      // If Impulse is loaded, its native click listener opens the drawer and stops propagation,
      // so this document-level fallback will not run. Only navigate when no drawer exists.
      if (!navDrawer) {
        event.preventDefault();
        window.location.href = categories.getAttribute('href') || '/collections';
      }
      return;
    }

    var cart = event.target.closest('[data-nv-mobile-bottom-cart]');
    if (cart) {
      var cartDrawer = document.getElementById('CartDrawer');
      if (!cartDrawer || !window.theme || !theme.settings || theme.settings.cartType !== 'drawer') {
        event.preventDefault();
        window.location.href = cart.getAttribute('href') || '/cart';
      }
    }
  });
})();
